module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$route.name === 'Orders') ? _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('order-top-panel'), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Загружаем заказы..."
    }
  }) : _vm._l((_vm.ordersDays), function(date) {
    return _c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-header"
    }, [_vm._v("\n      " + _vm._s(_vm.convertDataToString(date)) + "\n      "), _c('div', {
      staticClass: "pull-right"
    }, [_vm._v("\n        Заказов отмено: " + _vm._s(_vm.getOrdersCanceledByDate(date).length) + "\n        "), (_vm.showCanceled) ? _c('button', {
      staticClass: "ml-2 btn btn-sm btn-secondary",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showCanceled = false
        }
      }
    }, [_vm._v("Скрыть отмененые")]) : _c('button', {
      staticClass: "ml-2 btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showCanceled = true
        }
      }
    }, [_vm._v("Показать отмененые")])])]), _vm._v(" "), _c('div', {
      staticClass: "card-block orders-items"
    }, [_c('div', {
      staticClass: "row",
      staticStyle: {
        "margin-left": "-20px",
        "margin-right": "-20px"
      }
    }, [_c('div', {
      staticClass: "col-12 mt-1 mb-1 small  hidden-md-down"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-1"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-12 col-lg-7"
    }, [_vm._v("№")]), _vm._v(" "), _c('div', {
      staticClass: "col-12 col-lg-5"
    }, [_vm._v("Время")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-3 col-lg-2"
    }, [_vm._v("Статус")]), _vm._v(" "), _c('div', {
      staticClass: "col-2 col-lg-3"
    }, [_vm._v("Описание")]), _vm._v(" "), _c('div', {
      staticClass: "col-2"
    }, [_vm._v("Клиент")]), _vm._v(" "), _c('div', {
      staticClass: "col-2"
    }, [_vm._v("Город, компания, техцентр")]), _vm._v(" "), _c('div', {
      staticClass: "col-1",
      staticStyle: {
        "word-wrap": "break-word"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "col-1"
    }, [_vm._v("Действие")])])]), _vm._v(" "), _vm._l((_vm.getOrdersByDate(date)), function(order, index) {
      return _c('div', {
        key: order.id,
        staticClass: "col-12 order-item",
        class: {
          active: _vm.activeOrderId === order.id, 'text-danger': order.problem && !order.canceled, 'text-muted': order.canceled
        },
        attrs: {
          "id": _vm.getIdElement(order.id)
        }
      }, [_c('div', {
        staticClass: "row order-item-row",
        class: {
          active: _vm.activeOrderId === order.id,
            'order-item-row--commission-problem': _vm.getCommission(order.sum, order.profit) !== false && _vm.getCommission(order.sum, order.profit) < 10
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.showOrderDetail(order.id)
          }
        }
      }, [_c('div', {
        staticClass: "col-6 col-md-1"
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-12 col-lg-7"
      }, [_c('small', {
        staticClass: "hidden-md-up text-muted"
      }, [_vm._v("№ "), _c('br')]), _vm._v("\n                  " + _vm._s(order.id) + "\n                  "), _c('br'), _c('span', {
        staticClass: "text-muted small"
      }, [_vm._v(_vm._s(order.amoId))]), _vm._v(" "), (order.amoId) ? _c('a', {
        staticClass: "btn btn-secondary btn-sm",
        attrs: {
          "href": _vm.getAmoLeadUrl(order.amoId),
          "target": "_blank"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
          }
        }
      }, [_vm._v("Открыть"), _c('br'), _vm._v(" в AmoCRM")]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "col-12 col-lg-5"
      }, [_c('small', {
        staticClass: "hidden-md-up text-muted"
      }, [_vm._v("Время "), _c('br')]), _vm._v("\n                  " + _vm._s(order.time) + "\n                ")])])]), _vm._v(" "), _c('div', {
        staticClass: "col-6 col-md-3 col-lg-2"
      }, [_c('order-status', {
        attrs: {
          "order": order,
          "commission": _vm.getCommission(order.sum, order.profit)
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "col-6 col-md-5 col-lg-3"
      }, [_vm._v("\n              " + _vm._s(order.description) + "\n              "), (order.canceled) ? _c('div', {
        staticClass: "text-danger small"
      }, [_vm._v("\n                Причина отмены: " + _vm._s(order.cancelCause) + ".\n                "), (order.movedOrder) ? _c('span', [_c('a', {
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            $event.preventDefault();
            _vm.showMovedOrderDetail(order.movedOrder.id)
          }
        }
      }, [_vm._v("Заказ №" + _vm._s(order.movedOrder.id))]), _vm._v(" в "), _c('span', {
        staticClass: "badge",
        style: ({
          backgroundColor: order.movedOrder.techcenter.color
        })
      }, [_vm._v(_vm._s(order.movedOrder.techcenter.address))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (order.problem) ? _c('div', {
        staticClass: "text-danger small"
      }, [_c('i', {
        staticClass: "fa fa-exclamation-triangle",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" Проблема с заказом: " + _vm._s(order.problemCause))]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "col-6 col-md-3 col-lg-2"
      }, [_c('order-client-info', {
        attrs: {
          "order": order
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "col-6 col-md-9 col-lg-2"
      }, [_c('order-techcenter-info', {
        attrs: {
          "order": order
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "col-1"
      }, [_c('span', {
        directives: [{
          name: "b-tooltip",
          rawName: "v-b-tooltip"
        }],
        attrs: {
          "placement": "bottom",
          "title": _vm.getCreatedDescr(order)
        }
      }, [_c('i', {
        staticClass: "fa fa-clock-o"
      })]), _vm._v(" "), _c('span', {
        directives: [{
          name: "b-tooltip",
          rawName: "v-b-tooltip"
        }],
        attrs: {
          "placement": "bottom",
          "title": _vm.getCommentsDescr(order.commentsCountUnviewed)
        }
      }, [_c('span', {
        staticClass: "text-muted",
        class: {
          'text-warning': order.commentsCountUnviewed
        }
      }, [_c('i', {
        staticClass: "fa fa-comment-o"
      })]), _vm._v("\n                " + _vm._s(order.commentsCount) + "\n              ")])]), _vm._v(" "), _c('div', {
        staticClass: "col-1"
      }, [_c('order-actions', {
        attrs: {
          "order": order
        }
      })], 1)]), _vm._v(" "), (_vm.activeOrderId === order.id) ? _c('div', {
        staticClass: "row mt-2"
      }, [_c('hr'), _vm._v(" "), _c('div', {
        staticClass: "col-12 col-lg-6"
      }, [_c('comments', {
        attrs: {
          "order": order
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "col-12 col-lg-6"
      }, [_c('b-card', [_c('b-tabs', {
        ref: "tabs",
        refInFor: true,
        attrs: {
          "card": "",
          "lazy": true
        }
      }, [_c('b-tab', {
        attrs: {
          "title": "<i class='fa fa-history'></i> История изменений заказа",
          "active": ""
        }
      }, [_c('order-history', {
        attrs: {
          "order": order
        }
      })], 1), _vm._v(" "), (order.canViewCallHistory) ? _c('b-tab', {
        attrs: {
          "title": "<i class='fa fa-phone'></i> История звонков"
        }
      }, [_c('order-call-history', {
        attrs: {
          "order": order
        }
      })], 1) : _vm._e()], 1)], 1)], 1)]) : _vm._e()])
    })], 2)])])
  }), _vm._v(" "), (_vm.showAlertNoOrders) ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('h6', [_vm._v("К сожалению заказы по заданным параметрам не найдены. Попробуйте изменить параметры поиска или режим отображения заказов.")])]) : _vm._e()], 2) : _c('router-view')
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-269ff54d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-269ff54d"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Orders/List.vue
// module id = 1015
// module chunks = 1